export default __webpack_public_path__ + "static/media/2068.88ef3382.png";